import { render, staticRenderFns } from "./FolderPermissionSet.vue?vue&type=template&id=275e7232&"
import script from "./FolderPermissionSet.vue?vue&type=script&lang=js&"
export * from "./FolderPermissionSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports